import React, {Component} from 'react';
import './feature.css'
class Feature extends Component{
    render(){
        return(
        <div id="feature">
          <div className="container">
            <div className="row">
              <div className="col-md">
                <h3>Key Features</h3>
                <div className="feature-elements">
                  <ul className="list-unstyled feature-ul">
                    <li >
                      <img src={require('../../images/feature/keyicon-simplify-work.png')} alt="simplify-work" className="img-fluid" />
                      <p>Simplify Work</p>
                    </li>
                    <li>
                      <img src={require('../../images/feature/keyicon-reduce-cost.png')} alt="reduce-work" className="img-fluid" />
                      <p>Reduce Cost</p>
                    </li>
                    <li>
                      <img src={require('../../images/feature/keyicon-one-paltform.png')} alt="one-paltform" className="img-fluid" />
                      <p>One Platform</p>
                    </li>
                    <li>
                      <img src={require('../../images/feature/keyicon-improve-productivity.png')} alt="improve-productivity" className="img-fluid" />
                      <p>Improve <br /> Productivity</p>
                    </li>
                    <li>
                      <img src={require('../../images/feature/keyiocn-smart-decisions.png')} alt="smart-decisions" className="img-fluid" />
                      <p>Smart Decisions</p>
                    </li>
                    <li>
                      <img src={require('../../images/feature/keyicon-employee-engagement.png')} alt="employee-engagement" className="img-fluid" />
                      <p>Employee Engagement</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
    }
}

export default Feature;


// WEBPACK FOOTER //
// ./src/components/Features/Feature.js